import { useState } from 'react';
import { Derivation } from '../interfaces/Derivation';
import { SilaButton } from './SilaButton';

export const AutoAssignDerivationButton: React.FC<{
  selectedDerivation: Derivation | null;
  onTakeDerivation: () => void;
}> = ({ selectedDerivation, onTakeDerivation }) => {
  const [loading, setLoading] = useState(false);

  if (!selectedDerivation) return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      await onTakeDerivation();
    } finally {
      setLoading(false);
    }
  };

  return (
    <SilaButton
      onClick={handleClick}
      isLoading={loading}
      variant='primary'
      className='w-full'
    >
      Tomar derivación
    </SilaButton>
  );
};
